(function() {
    'use strict';

a3_pilot_reports.directive('proposal', proposal);
   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name proposal
   * @restrict E
   * @description
   *   Implementation of proposal
   *   Initialize the proposal element of bucket
   * @example
   *   Usage:
   *   <proposal    proposal="proposal"  
   *                current-duty-id="currentDutyId"  
   *                current-duty-date="currentDutyDate" 
   *                onDisplay="functionCallback" 
   *                onRefresh="functionCallback"
   *                action-disabled="approvedDuty" 
   *                shared-count="duty.Duties.length"
   *    </proposal>
   * @ngInject
   */    
function proposal(BucketFactory, $uibModal, $filter) {
     function link(scope, element, attrs){
        scope.isOpen = false;
        scope.successful = false;
        scope.error = false;
        scope.proposal.createDisabled = false;
       
        scope.duty = scope.proposal.Duty;
        
        scope.loading = false;
        scope.errorMessage = null;
       
        scope.ProposedDuties = new Array();
        scope.RequestedDuties = new Array();
        scope.AllDuties = new Array();

        scope.fetch = fetchInformation;
        scope.viewInfoModal = viewInfoModal;
        scope.createProposal = createProposal;
        scope.evaluateProposal = evaluateProposal;
        scope.undoProposalStatus = undoProposalStatus;
        scope.acknowledgeProposal = acknowledgeProposal;
        scope.confirmCreateProposal = confirmCreateProposal;
        scope.getFirstInfoIcon = getFirstInfoIcon;
        scope.getSecondInfoIcon = getSecondInfoIcon;
        scope.hasSecondInfoIcon = hasSecondInfoIcon;
        scope.getTextColor = getTextColor;
        scope.getFirstActionIcon = getFirstActionIcon;
        scope.hasFirstActionIcon = hasFirstActionIcon;
        scope.getSecondActionIcon = getSecondActionIcon;
        scope.hasSecondActionIcon = hasSecondActionIcon;
        scope.getFetchIcon = getFetchIcon;
        scope.getInfoMessage = getInfoMessage;
        scope.firstAction = firstAction;
        scope.secondaryAction = secondaryAction;
        scope.showEndDate = showEndDate;
        scope.showTime = showTime;


        if(scope.duty.Comments && scope.duty.Comments != ""){
            scope.dutyCommentElipsis = dutyCommentElipsis(110);
            scope.showFullComment = false;
        }
        
        scope.toggleFullCommentVisibility = toggleFullCommentVisibility;

        /**
         * Toggles proposal comment
         * @memberof proposal
         */
        function toggleFullCommentVisibility(){
            scope.showFullComment =  !scope.showFullComment;
        }

        /**
         * Shows only the first charNo characters of the comment
         * @memberof proposal
         * @param {number} charNo 
         */
        function dutyCommentElipsis(charNo){
            var comments = scope.duty.Comments;
            if(scope.duty.Comments.length > charNo){
               comments = scope.duty.Comments.substring(0,charNo) + "...";
            }
            return comments;
        }

         /**
         * Updates proposal when a change occurs (create, evaluate or undo)
         * @memberof proposal
         * @param {object} newProp - The updated proposal 
         */
        function updateProposal(newProp){
            if(newProp){
                 scope.proposal.Status =  newProp.Status;
                 scope.proposal.State = newProp.State;
                 scope.proposal.Id = newProp.Id;
                 scope.proposal.isAcknowledged = newProp.isAcknowledged;
             }   
        }
         
        /**
         * Fetches proposal info (Proposed and Requested duties alongside Crew and Route details for each one)  
         * @memberof proposal
         */
        function fetchInformation(){
            if(!(scope.actionDisabled && scope.proposal.Status == 'Shared')){
                //only fetch the first time
                if(!(scope.proposal.AllDuties && scope.proposal.AllDuties.length>0)){
                    scope.loading = true;
                    if(scope.proposal.Status == "Shared" && !scope.actionDisabled){

                        BucketFactory.fetchSharedProposal(scope.currentDutyId, scope.duty.Id, insertInformation )
                        .catch(errorCall);
                    }else{
                        BucketFactory.fetchProposal(scope.proposal.Id, insertInformation)
                        .catch(errorCall);
                    }
                }else{
                    scope.isOpen = !scope.isOpen;   //collapse
                }
            }
        }
        
        /**
         * Handles error from fetchSharedProposal() and fetchProposal()  
         * @memberof proposal
         */
        function errorCall(){
            scope.isOpen = false;
            scope.loading = false;
            displayMessage("Failed to fetch information.", true);
        }

        /**
         * Callback for handling the successful response of fetchSharedProposal() and fetchProposal()
         * @memberof proposal
         * @param {object} data 
         */
        function insertInformation(data){
            var success = data.data.success;
            var errorMessage = data.data.errorMessage;
            //always show duties even if success is false
            if(data.data.data.duty){
                var ProposedDuties = data.data.data.duty.ProposedDuties;
                var RequestedDuties = data.data.data.duty.RequestedDuties;
                scope.proposal.HasMultiDuties = data.data.data.duty.HasMultiDuties;

                ProposedDuties  = $filter('orderBy')(ProposedDuties, 'DutyDate');
                RequestedDuties  = $filter('orderBy')(RequestedDuties, 'DutyDate');

                if(ProposedDuties && RequestedDuties){
                    scope.proposal.AllDuties = [];   
                    var tableMaxRowLength = (ProposedDuties.length > RequestedDuties.length) ? ProposedDuties.length : RequestedDuties.length;
    
                    for(var i = 0; i < tableMaxRowLength; i++){
                        
                        if(scope.proposal.Status == "Shared" || scope.proposal.State == "Out"){
                            var matchedDuty = {
                                Proposed : ProposedDuties[i],   //you give
                                Requested : RequestedDuties[i]  //you take
                            };
                        }
                        else{   //scope.proposal.State == "In"
                            var matchedDuty = {
                                Proposed : RequestedDuties[i],  //you give
                                Requested : ProposedDuties[i]   //you take
                            };
                        }
                        
                    scope.proposal.AllDuties.push(matchedDuty);
                    } 
                    
                    scope.proposal.ProposedDuties  = ProposedDuties;
                    scope.proposal.RequestedDuties = RequestedDuties;
                    scope.isOpen = true;          
                }
            }

            if(!success){
                //if not enough rest time
                //if no available combinations
                scope.proposal.createDisabled = true;
            }else{
                scope.proposal.createDisabled = false;
            }

            //always show errorMessage even if success is true
            if(errorMessage && errorMessage.length > 0){
                displayMessage(errorMessage, true);
            }
            else{
                scope.errorMessage = null;
            }
           

            scope.loading = false;
        }
 
        /**
         * Opens modal for a specific duty in the table - Shows route and crew info 
         * @memberof proposal
         * @param {number} id 
         */
        function viewInfoModal(id){
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Bucket/dlgProposalInfo.html',
                controller: 'ProposalInfoModalCtr',
                size: 'lg',
                resolve: {
                    ProposedDuties: function () { return scope.proposal.ProposedDuties; },
                    RequestedDuties: function () { return scope.proposal.RequestedDuties; },
                    Id: function () {return id; },
                    Status: function () { return scope.proposal.Status; },
                    State: function () { return scope.proposal.State; }
                }
            });
        }

        /**
         * Creates/Sends proposal
         * @memberof proposal
         */
        function createProposal(){
            var proposedDutiesIdList = [];
            var requestedDutiesIdList = [];

            angular.forEach(scope.proposal.ProposedDuties,function(duty){
                proposedDutiesIdList.push(duty.Id);
            });

            angular.forEach(scope.proposal.RequestedDuties,function(duty){
                requestedDutiesIdList.push(duty.Id);
            });


            //request body
            var proposal = {
                'proposedDutiesIdList' : proposedDutiesIdList,
                'requestedDutiesIdList' : requestedDutiesIdList
            };

            scope.loading = true;

            BucketFactory.createProposal(proposal, function (responseData) {
                displayMessage("Proposal has been sent", false);
                scope.loading = false;
                updateProposal(responseData.data.data);
                if(scope.proposal.HasMultiDuties){     
                    scope.refresh();   //needed in order to hide other duty from same proposal
                }
             })
             .catch(function(){
                 displayMessage("Failed to sent proposal.", true);
                 scope.loading = false;
             });
        }

        /**
         * Approves/Rejects proposal
         * @memberof proposal
         * @param {boolean} isApproved
         */
        function evaluateProposal(isApproved){
            var proposal = {};
            proposal.Id = scope.proposal.Id;
            proposal.isApproved = isApproved;
                
            var onSuccessMessage, onFailureMessage;
            
            if(isApproved){
                proposal.Status = "Approved";
                var onSuccessMessage = "Approved proposal.";
                var onFailureMessage = "Failed to approve proposal.";
            }
            else{
                proposal.Status = "Rejected";
                var onSuccessMessage = "Rejected proposal.";
                var onFailureMessage = "Failed to reject proposal.";
            }
            
            scope.loading = true;
            BucketFactory.evaluateProposal(proposal).then(function (responseData) {
                var success = responseData.data.success;
                if(success){
                    var newProp = responseData.data.data;
                    updateProposal(newProp);
                    if(isApproved){
                       scope.refresh();    //needed in order to disable other proposals
                    }
                    displayMessage(onSuccessMessage,false);
                }else{
                    displayMessage(onFailureMessage,true);
                }
            })
            .catch(function(){
                    displayMessage(onFailureMessage,true);
            });

            scope.loading = false;
        }

        /**
         * Reverts proposal to previous status
         * @memberof proposal
         */
        function undoProposalStatus(){
            scope.loading = true;
            var proposal = {};
            proposal.Id = scope.proposal.Id;

            var onSuccessMessage, onFailureMessage;

            if((scope.proposal.Status == "Approved") ||
                (scope.proposal.Status == "Rejected" && scope.proposal.State=='In')){
                    var onSuccessMessage = "Proposal has been reset.";
                    var onFailureMessage = "Failed to reset proposal.";
            }else{ //(scope.proposal.Status == "Pending" && scope.proposal.State=='Out')
                var onSuccessMessage = "Withdrew proposal.";
                var onFailureMessage = "Failed to withraw proposal.";
            }

            
            BucketFactory.undoProposalStatus(proposal.Id).then(function (responseData) {
                var previousStatus = scope.proposal.Status;
                var HasMultiDuties = scope.proposal.HasMultiDuties;
                var newProp = responseData.data.data;
                displayMessage(onSuccessMessage, false);
                scope.loading = false;
                updateProposal(newProp);
                if(previousStatus == "Approved"){
                    scope.refresh();        //needed in order to enable other proposals again        
                }
                else if(previousStatus == "Pending" && HasMultiDuties){
                    scope.refresh();        //needed in order to show other duties from same proposal       
                }
            })
            .catch(function(){
                scope.loading = false;
                displayMessage(onFailureMessage,true);
            });

        }

        /**
         * Displays error or success message
         * @memberof proposal
         * @param {string} message 
         * @param {boolean} hasErrors 
         */
        function displayMessage(message, hasErrors){
            
            if(hasErrors){
                scope.errorMessage = message;
            }else{
                scope.errorMessage = null;
            }
        }
        
        /**
         * Makes proposal acknowledged 
         * Available when status is 'RejectedBySTP' or status is 'Rejected' and state  is 'Out'
         * @memberof proposal
         */
        function acknowledgeProposal(){
            scope.loading = true;
            var proposalId = scope.proposal.Id;
            var onFailureMessage = "Failed to acknowledge proposal.";
            
            BucketFactory.acknowledgeProposal(proposalId).then(function (responseData) {
                scope.proposal.isAcknowledged = true;
                scope.loading = false;
            })
            .catch(function(){
                 scope.loading = false;
                 displayMessage(onFailureMessage, true);
            });
        }
     
        /**
         * Changes proposal's first info icon depending on its state and status
         * @memberof proposal
         * @returns {string} - Icon name
         */
        function getFirstInfoIcon(){
            var icon = ""
            if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out' ){
                icon="fa-thumbs-up";
            }else if(scope.proposal.Status == "Rejected"){
                  icon="fa-thumbs-down";
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In'){
                  icon="fa-thumbs-o-up";
            }else if (  scope.proposal.Status == "Shared"){
                icon="fa-bitbucket";
            }else if(scope.proposal.Status == "Approved"){
                icon = "fa fa-handshake-o"
            }else if (  scope.proposal.Status == "ApprovedBySTP"){
                icon="fa-thumbs-up";
            }else if(scope.proposal.Status == "RejectedBySTP"){
                icon="fa-thumbs-o-down";
            }
            return icon;
        }

         /**
         * Changes proposal's second info icon depending on its state and status
         * @memberof proposal
         * @returns {string} - Icon name
         */
        function getSecondInfoIcon(){
             var icon = ""
            if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out' ){
                icon="fa-clock-o text-gray";
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In'){
                icon="fa-question-circle-o";
            }
            return icon;
        }   

        /**
         * Determines second info icon's visibility
         * @memberof proposal
         * @returns {boolean}
         */
        function hasSecondInfoIcon(){
           return (scope.proposal.Status == "Pending"  && scope.proposal.State == 'In' ) ||(scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out');     
        }

        /**
         * Changes column color depending on proposal's state and status
         * @memberof proposal
         * @returns {string} - Color's class
         */
        function getTextColor(){
            var textclass="";
            if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out' ){
                textclass="text-light-blue";
            }else if(scope.proposal.Status == "Rejected"){
                textclass="text-red";
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In'){
                textclass="text-orange";
            }else if(scope.proposal.Status == "Approved" ){
                textclass="text-green";
            }else if (  scope.proposal.Status == "Shared"){
                textclass="text-blue-gray";
            }else if (  scope.proposal.Status == "ApprovedBySTP"){
                textclass="text-green";
            }else if(scope.proposal.Status == "RejectedBySTP"){
                textclass="text-red";
            }
            return textclass;
        }

        /**
         * Changes proposal's first action icon depending on its state and status
         * @memberof proposal
         * @returns {string} - Icon name
         */
        function getFirstActionIcon(){
            var icon = ""
            if(scope.proposal.createDisabled){
                icon = "fa-ban text-red";               //no action permitted
            }else if((scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out' )
                    ||scope.proposal.Status == "Approved"  ){
                icon=" fa-times text-gray ";            //undo
            }else if(scope.proposal.Status == "Rejected" && scope.proposal.State == "In"){
                icon=" fa-times text-gray ";          //undo
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In' && !scope.actionDisabled){
                icon="fa-thumbs-o-up text-green";     //approve
            }else if (  scope.proposal.Status == "Shared" && !scope.actionDisabled){
                icon="fa-thumbs-o-up text-light-blue";  //create
            }
            
            return icon;
        }
        
        /**
         * Changes proposal's fetch icon if create action is disabled  
         * @memberof proposal
         * @returns {string} - Icon name
         */
        function getFetchIcon(){
            var icon = "";
            if(scope.proposal.createDisabled){
                icon = "fa-ban text-red";
            }
            else{
                icon = "fa-search";
            }
            return icon;
        }

        /**
         * Changes proposal's second action icon depending on its state and status
         * @memberof proposal
         * @returns {string} - Icon name
         */
        function getSecondActionIcon(){
            var icon = ""
            if(scope.proposal.Status == "Pending" && scope.proposal.State == 'In'){
                  icon="fa-thumbs-o-down text-red";     //reject
            }
         return icon;

        }  
        
         /**
         * Determines first action icon's visibility
         * @memberof proposal
         * @returns {boolean}
         */
        function hasFirstActionIcon(){
            return !(  scope.proposal.Status == "ApprovedBySTP" ||  scope.proposal.Status == "RejectedBySTP") ;
        }
         
        /**
         * Determines second action icon's visibility
         * @memberof proposal
         * @returns {boolean}
         */
        function hasSecondActionIcon(){
            return (scope.proposal.Status == "Pending"  && scope.proposal.State == 'In') ||  (  scope.proposal.Status == "Shared");
        }
        
        /**
         * Returns info message depending on proposal's state and status
         * @memberof proposal
         * @returns {string} - Message
         */
        function getInfoMessage(){
            var text="";
            if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'Out' ){
                text="your proposal is pending";
            }else if(scope.proposal.Status == "Rejected" && scope.proposal.State == 'Out'){
                  text="your proposal has been rejected";
            }
            else if(scope.proposal.Status == "Rejected" && scope.proposal.State == 'In'){
                  text="you have rejected the proposal";
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In'){
                  text="your response is pending";
            }else if(scope.proposal.Status == "Approved" && scope.proposal.State == 'In' ){
                text="you have accepted the proposal. Your request is sent for approval";
            }else if(scope.proposal.Status == "Approved" && scope.proposal.State == 'Out' ){
                text="your proposal has been accepted! Your request is sent for approval";
            }else if (  scope.proposal.Status == "ApprovedBySTP"){
                text="your request has been approved!";
            }else if(scope.proposal.Status == "RejectedBySTP"){
                text="your request has been rejected by STP";
            }
             
            return text;
        }

        /**
         * Determines duty's endDate visibility
         * @memberof proposal
         * @returns {boolean}
         */
        function showEndDate(duty){
            var show = false;
            var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);
            var diffHours = diffMin / 60;
            if(diffHours >= 24){            //endDate will show if duty exceeds 24 hours
                show = true;
            }
            return show;
        }

        /**
         * Hides duty begin and end time if needed
         * @param {object} duty 
         */
        function showTime(duty){
            var show = true;
            var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);
            if(!diffMin){            //Time will not show if duty lasts all day (ex. Day Off: 00:00 - 00:00)
                show = false;
            }
            return show;
        }

        /**
         * Chooses first icon's action depending on proposal's state and status
         * @memberof proposal
         */
        function firstAction(){
            if(scope.proposal.Status == "Pending" && scope.proposal.State == 'Out' ){
                undoProposalStatus();
            }else if(scope.proposal.Status == "Approved" ){
                confirmUndoApproved();
            }else if(scope.proposal.Status == "Rejected" && scope.proposal.State == 'In'){
                undoProposalStatus();
            }else if(scope.proposal.Status == "Pending"  && scope.proposal.State == 'In'){
                evaluateProposal(true); //approve
            }else if( scope.proposal.Status == "Shared" && !scope.proposal.createDisabled){
                if(scope.errorMessage && scope.errorMessage.length > 0){
                    confirmCreateProposal(); //fetch success with errorMessage
                }
                else{
                    createProposal();
                }
            }
        }
         
        /**
         * Chooses second icon's action depending on proposal's state and status
         * @memberof proposal
         */
        function secondaryAction(){
            if(scope.proposal.Status == "Pending" && scope.proposal.State == 'In'){
                evaluateProposal(false); // reject proposal
            }
         }

         /**
         * Opens confirmation modal when undo is requested on an approved proposal
         * @memberof proposal
         */
        function confirmUndoApproved() {
            bootbox.dialog({
                message: "<strong>You are about to cancel your accepted proposal.</strong><br/><br/>",
                title: "Caution!",
                buttons: {
                     confirm:{
                        label: 'Confirm',
                        className: "btn-danger",
                        callback: function(){
                            undoProposalStatus();
                        }
                    },  
                    cancel:{
                        label: "Cancel",
                        className: "btn-default",
                        callback: function(){}
                    }
                }
            })
        }
        
        /**
         * Opens confirmation modal when create is requested on an alternate proposal
         * @memberof proposal
         */
        function confirmCreateProposal() {
            bootbox.dialog({
                message: "<strong>Would you like to proceed with the alternate proposal?</strong><br/><br/>",
                title: "Send request",
                buttons: {
                     confirm:{
                        label: 'Confirm',
                        className: "btn-success",
                        callback: function(){
                            createProposal();
                        }
                    },  
                    cancel:{
                        label: "Cancel",
                        className: "btn-default",
                        callback: function(){}
                    }
                }
            })
        }       

    }
    
    return {
			restrict: 'E',
			terminal: true,
            templateUrl: 'views/bucket/proposal.tpl.html',
			scope : {
                proposal: '=',
                displayMessage : '&onDisplay',
                refresh : '&onRefresh',
                actionDisabled: '=',
                currentDutyDate: '=',
                currentDutyId : '=',
                sharedCount : '='
            },
            link: link
    }
}

})();